import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import Compressor from 'compressorjs';

import { Box, Button, Typography, FormHelperText } from '@mui/material';

import { setReceiptImage, setShowReceiptUploadHelperTxt } from '@store/order/slice';

import '@template/components/InfosPart/ReceiptUpload/ReceiptUpload.scss';

const ReceiptUpload = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { receiptImage, showReceiptUploadHelperTxt } = useSelector((state) => state.order);

    const [fileName, setFileName] = useState(
        t('common.paymentMethod.bankpay.noFileUpload')
    );
    const [helperTxt, setHelperTxt] = useState('');

    useEffect(() => {
        setShowReceiptUploadHelperTxt(false);
    }, []);

    useEffect(() => {
        if(showReceiptUploadHelperTxt) {
            setHelperTxt(t('common.paymentMethod.bankpay.needBankReceipt'))
        } else {
            setHelperTxt('');
        }
    }, [showReceiptUploadHelperTxt]);

    const convertImage = (file) => {
        return new Promise(function(resolve, reject) {
             new Compressor(file, { maxWidth: 1024, maxHeight: 1024, success(result) {
                if (result instanceof Blob) {
                    resolve(new File([result], file.name, { type: result.type }));
                } else {
                    resolve(result);
                }
            }})
        })
    }

    return (
        <Box className="receiptUploadWrapper">
            <input
                id="receiptUpload"
                type="file"
                accept="image/jpg, image/jpeg, image/png"
                multiple
                onChange={async (event) => {
                    dispatch(setShowReceiptUploadHelperTxt(false));
                    let arr = [];
                    for(let idx = 0; idx < event.target.files.length && idx < 3; ++idx) {
                        let image = await convertImage(event.target.files[idx]);
                        arr.push(image);
                    }
                    dispatch(setReceiptImage(arr)); 
                }}
            />
            <label htmlFor="receiptUpload">
                <Button
                    variant="contained"
                    component="span"
                    className="btn uploadBtn">
                    {t('common.button.upload')}
                </Button>
            </label>
            { (receiptImage == null || receiptImage.length == 0) && <Typography>{fileName}</Typography> }
            { (receiptImage != null && receiptImage.map((image, idx) => {
                return (
                    <div key={idx}>
                        <img className="preview" src={URL.createObjectURL(image)} />
                    </div>
                )
            }))}
            <FormHelperText className="inputFieldHelperTxt">
                {helperTxt}
            </FormHelperText>
        </Box>
    );
};

export default ReceiptUpload;
